import React from 'react';
export default function RedText(props) {
    return (React.createElement("span", { className: "required" }, props.text));
}
